import { FETCH_ORDER, FETCH_ORDERS, REQUEST_FETCH_ORDERS, REQUEST_FETCH_ORDER } from '../actions/Types'
const orderReducer = (state={loading: false, data: []}, action) => {
    switch(action.type){
        case REQUEST_FETCH_ORDERS:
        case REQUEST_FETCH_ORDER:
            return {loading: true, data: []}
        case FETCH_ORDERS:
            return {loading: false, data: action.payload}
        case FETCH_ORDER:
            return {loading: false, data: [...state.data, action.payload]}
        default:
            return state
    }
}

export default orderReducer;